import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4863bd90")

_pushScopeId("data-v-4863bd90")
const _hoisted_1 = { class: "serif-commands" }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "セリフを入れる", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", { class: "h-line" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "bold" }, "フォント", -1)
const _hoisted_6 = { class: "font-commands commands" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "サイズ:", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, "フォント色:", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "マーカー色:", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", { class: "h-line" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "bold" }, "テキストボックス", -1)
const _hoisted_12 = { class: "object-commands commands" }
const _hoisted_13 = { class: "v-switch" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", null, "行間:", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("hr", { class: "h-line" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "center" }, [
  /*#__PURE__*/_createVNode("div", { class: "usage" }, [
    /*#__PURE__*/_createVNode("p", { class: "bold" }, "セリフの編集操作"),
    /*#__PURE__*/_createVNode("p", null, "再編集 ：テキストボックスをダブルクリック"),
    /*#__PURE__*/_createVNode("p", null, "テキストボックスの削除 ：【Delete】")
  ])
], -1)
const _hoisted_17 = {
  key: 0,
  class: "h-line"
}
const _hoisted_18 = {
  key: 1,
  class: "bold"
}
const _hoisted_19 = {
  key: 2,
  class: "center"
}
const _hoisted_20 = { class: "commands large-label" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "wrap left" }, [
  /*#__PURE__*/_createTextVNode("テンプレートのふきだし、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 効果音の表示")
], -1)
const _hoisted_22 = {
  key: 3,
  class: "h-line sample-line"
}
const _hoisted_23 = {
  key: 4,
  class: "h-line sample-line-famous"
}
const _hoisted_24 = { class: "center sample" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "マンガ広告サンプル集", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputCustomDropdown = _resolveComponent("InputCustomDropdown")
  const _component_InputToggle = _resolveComponent("InputToggle")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_InputToggleSwitch = _resolveComponent("InputToggleSwitch")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        class: "app-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editStore?.addText('', _ctx.selectedSize.value, _ctx.selectedLineHeight)))
      }, [
        _hoisted_3
      ])
    ]),
    _hoisted_4,
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_InputCustomDropdown, {
        class: "input",
        items: _ctx.fontSizes,
        disabled: _ctx.isTextDisabled,
        selectedValue: _ctx.selectedSize,
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editingObject = _ctx.editStore?.state.selectedObject)),
        "onUpdate:selectedValue": _cache[3] || (_cache[3] = 
          (size) => {
            _ctx.selectedSize = size;
            _ctx.setFontSize(size.value, _ctx.editingObject);
          }
        )
      }, {
        default: _withId(({ item, isDropItem }) => [
          _createVNode("span", {
            class: ["font-size", { 'is-dropitem': isDropItem }]
          }, _toDisplayString(item.value), 3)
        ]),
        _: 1
      }, 8, ["items", "disabled", "selectedValue"]),
      _hoisted_8,
      _createVNode(_component_InputCustomDropdown, {
        class: "input",
        items: _ctx.fontFores,
        disabled: _ctx.isTextDisabled,
        selectedValue: _ctx.selectedFontFore,
        "onUpdate:selectedValue": _cache[4] || (_cache[4] = 
          (item) => {
            _ctx.selectedFontFore = item;
            _ctx.editStore?.setFontColor(item.value);
          }
        )
      }, {
        default: _withId(({ item, isDropItem }) => [
          _createVNode("span", {
            class: ["circle", {
              'is-dropitem': isDropItem,
              stripe: item.value == 'F00000000',
            }],
            style: {
              'background-color': item.value,
            }
          }, null, 6)
        ]),
        _: 1
      }, 8, ["items", "disabled", "selectedValue"]),
      _hoisted_9,
      _createVNode(_component_InputCustomDropdown, {
        class: "input",
        items: _ctx.fontBacks,
        disabled: _ctx.isTextDisabled,
        selectedValue: _ctx.selectedFontBack,
        "onUpdate:selectedValue": _cache[5] || (_cache[5] = 
          (item) => {
            _ctx.selectedFontBack = item;
            _ctx.editStore?.setHiliteColor(item.value);
          }
        )
      }, {
        default: _withId(({ item, isDropItem }) => [
          _createVNode("span", {
            class: ["circle", {
              'is-dropitem': isDropItem,
              stripe: item.value == '#00000000',
            }],
            style: {
              'background-color': item.value,
            }
          }, null, 6)
        ]),
        _: 1
      }, 8, ["items", "disabled", "selectedValue"])
    ]),
    _hoisted_10,
    _hoisted_11,
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_InputToggle, {
          class: "toggle",
          disabled: _ctx.isTextDisabled,
          checked: _ctx.editStore?.state.selectedObject?.isVertical,
          "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editStore?.setVertical($event))),
          label: "たて"
        }, null, 8, ["disabled", "checked"]),
        _createVNode(_component_InputToggle, {
          class: "toggle",
          disabled: _ctx.isTextDisabled,
          checked: !_ctx.editStore?.state.selectedObject?.isVertical,
          "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editStore?.setVertical(!$event))),
          label: "よこ"
        }, null, 8, ["disabled", "checked"])
      ]),
      _hoisted_14,
      _createVNode(_component_InputNumber, {
        class: "input scale",
        disabled: _ctx.isTextDisabled,
        value: _ctx.selectedLineHeight,
        minValue: 1,
        maxValue: 99,
        defValue: 16,
        suffix: "px",
        onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editingObject = _ctx.editStore?.state.selectedObject)),
        "onUpdate:value": _cache[9] || (_cache[9] = 
          (v) => {
            _ctx.setLineHeight(Number.parseInt(v), _ctx.editingObject);
          }
        )
      }, null, 8, ["disabled", "value"])
    ]),
    _hoisted_15,
    _hoisted_16,
    (!_ctx.isFamous)
      ? (_openBlock(), _createBlock("hr", _hoisted_17))
      : _createCommentVNode("", true),
    (!_ctx.isFamous)
      ? (_openBlock(), _createBlock("p", _hoisted_18, "ふきだし・効果音"))
      : _createCommentVNode("", true),
    (!_ctx.isFamous)
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_InputToggleSwitch, {
              class: "input",
              checked: _ctx.editStore?.state.selectedEdit?.isBalloonOn,
              "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => (_ctx.editStore?.setBalloonOn($event)))
            }, null, 8, ["checked"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isFamous)
      ? (_openBlock(), _createBlock("hr", _hoisted_22))
      : _createCommentVNode("", true),
    (_ctx.isFamous)
      ? (_openBlock(), _createBlock("hr", _hoisted_23))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_24, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openExample && _ctx.openExample(...args)))
      }, [
        _hoisted_25
      ])
    ])
  ]))
})